import { epicRequest, serverResponse } from 'app'

export const PLATFORM_DATA_FETCH = 'PLATFORM_DATA_FETCH'
export const PLATFORM_DATA_FETCH_ERROR = 'PLATFORM_DATA_FETCH_ERROR'
export const PLATFORM_DATA_FETCH_FULFILLED = 'PLATFORM_DATA_FETCH_FULFILLED'
export const PLATFORM_DATA_FETCH_CANCELED = 'PLATFORM_DATA_FETCH_CANCELED'

export const getPlatformInitialState = serverResponse

export const platformDataFetch = () => ({
  payload: null,
  type: PLATFORM_DATA_FETCH,
})

export const platformDataFetchFulfilled = (payload) => ({
  payload,
  type: PLATFORM_DATA_FETCH_FULFILLED,
})

export const platformDataFetchCanceled = () => ({
  payload: null,
  type: PLATFORM_DATA_FETCH_CANCELED,
})

export const platformDataFetchError = (payload) => ({
  payload,
  type: PLATFORM_DATA_FETCH_ERROR,
})

export const platformDataFetchEpic = epicRequest({
  actionType: PLATFORM_DATA_FETCH,
  errorAction: platformDataFetchError,
  fulfilledAction: platformDataFetchFulfilled,
  request: 'platform/data',
  untilTypes: PLATFORM_DATA_FETCH_CANCELED,
})
